export default class Die {
	constructor(faces = [1, 2, 3, 4, 5, 6]) {
		this.face = faces[Math.floor(Math.random() * faces.length)]
		this.held = false
		this.element = null
	}
	roll(faces) {
		this.face = faces[Math.floor(Math.random() * faces.length)]
		this.rotateRandomly()
	}
	animateRoll(faces) {
		document.getElementById('audio-dice').play()
		let int = setInterval(() => this.roll(faces), 50);
		setTimeout(() => { clearInterval(int) }, 400);
	}
	rotateRandomly() {
		let min = -.1;
		let max = 0.1;
		let delta = max - min
		const travel = delta * Math.random()
		this.element.children[0].style.transform = `rotate(${min + travel}turn)`
	}
	resetPosition() {
		this.held = false;
		this.element.setAttribute('data-x', 0);
		this.element.setAttribute('data-y', 0);
		this.element.style.transform = 'translate(0,0)';
	}
}
